import React from 'react';

import { DatePicker } from '../../date-picker/date-picker';
import { FormHelperText } from '../../form-helper-text/form-helper-text';
import { DateFilterComponent } from '../date-filter.types';

const style = {
  datePicker: 'flex flex-col gap-2 pl-11 pb-2',
};

export const DateFilterAfter: React.FC<DateFilterComponent> = ({ dateError, filter, onChange }) => {
  return (
    <div className={style.datePicker}>
      <DatePicker
        selectedDate={filter.startDate}
        onChange={(date) => {
          onChange({ startDate: date });
        }}
        containerSize="large"
      />
      {dateError?.start && (
        <FormHelperText type={'error'} size="medium" display={dateError.start} visible={true} showIcon={true} />
      )}
    </div>
  );
};

export default DateFilterAfter;
